import type { ReactNode } from "react";

/** `action` sits at the end of the band, after the note. A control that acts
 *  on what the band names belongs inside it: the star means "this item, this
 *  mode", which is exactly what the title already says, and a button floating
 *  above the panel would have to repeat that to be legible. */
export function TitleBand({ title, note, action }: {
  title: string; note?: string; action?: ReactNode;
}) {
  return (
    <div className="title-band">
      <span>{title}</span>
      {note ? <span className="note">{note}</span> : null}
      {action ? <span className="action">{action}</span> : null}
    </div>
  );
}
